/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SpinWheelOutcome } from './SpinWheelOutcome';
import {
    SpinWheelOutcomeFromJSON,
    SpinWheelOutcomeFromJSONTyped,
    SpinWheelOutcomeToJSON,
    SpinWheelOutcomeToJSONTyped,
} from './SpinWheelOutcome';

/**
 * 
 * @export
 * @interface SpinWheelResponseWheelConfig
 */
export interface SpinWheelResponseWheelConfig {
    /**
     * 
     * @type {string}
     * @memberof SpinWheelResponseWheelConfig
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SpinWheelResponseWheelConfig
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof SpinWheelResponseWheelConfig
     */
    modalTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof SpinWheelResponseWheelConfig
     */
    modalDescription?: string;
    /**
     * 
     * @type {Array<SpinWheelOutcome>}
     * @memberof SpinWheelResponseWheelConfig
     */
    outcomes?: Array<SpinWheelOutcome>;
}

/**
 * Check if a given object implements the SpinWheelResponseWheelConfig interface.
 */
export function instanceOfSpinWheelResponseWheelConfig(value: object): value is SpinWheelResponseWheelConfig {
    return true;
}

export function SpinWheelResponseWheelConfigFromJSON(json: any): SpinWheelResponseWheelConfig {
    return SpinWheelResponseWheelConfigFromJSONTyped(json, false);
}

export function SpinWheelResponseWheelConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpinWheelResponseWheelConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'modalTitle': json['modalTitle'] == null ? undefined : json['modalTitle'],
        'modalDescription': json['modalDescription'] == null ? undefined : json['modalDescription'],
        'outcomes': json['outcomes'] == null ? undefined : ((json['outcomes'] as Array<any>).map(SpinWheelOutcomeFromJSON)),
    };
}

export function SpinWheelResponseWheelConfigToJSON(json: any): SpinWheelResponseWheelConfig {
    return SpinWheelResponseWheelConfigToJSONTyped(json, false);
}

export function SpinWheelResponseWheelConfigToJSONTyped(value?: SpinWheelResponseWheelConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'modalTitle': value['modalTitle'],
        'modalDescription': value['modalDescription'],
        'outcomes': value['outcomes'] == null ? undefined : ((value['outcomes'] as Array<any>).map(SpinWheelOutcomeToJSON)),
    };
}

